<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <h1 class="t-inverse t-center">
        You're all set!
      </h1>

      <p class="t-inverse t-center">
        Thank you for signing up.
        <br>
        We have sent a verification email to <strong>{{ user.email }}</strong>
      </p>

      <p class="t-inverse t-center">When you get this email, please verify your account.</p>
    </div>
  </layout-fullscreen>
</template>

<script>
  import { mapState } from 'vuex';
  import LayoutFullscreen from '@/layouts/Fullscreen';

  export default {
    name: 'AccountActivate',

    components: {
      LayoutFullscreen
    },

    computed: {
      ...mapState([
        'user'
      ])
    }
  };
</script>